export default {
	install: Vue => {
		Vue.filter('tamano', (tamano) => {
			if (!tamano) {
				return '0 kB'
			}

			let bytes = tamano
			const si = true
			var thresh = si ? 1000 : 1024
			if (Math.abs(bytes) < thresh) {
				return bytes + ' B'
			}
			var units = si
				? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
				: ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
			var u = -1
			do {
				bytes /= thresh
				++u
			} while (Math.abs(bytes) >= thresh && u < units.length - 1)
			return bytes.toFixed(1) + ' ' + units[u]
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/core/vue/libs/filtroTamano.js